/** Human-readable turn/conversation duration. */
export function formatDuration(milliseconds: number): string {
  if (!milliseconds || milliseconds === 0) return "—";
  if (milliseconds < 1000) return `${milliseconds}ms`;
  if (milliseconds < 60000) return `${(milliseconds / 1000).toFixed(1)}s`;
  return `${(milliseconds / 60000).toFixed(1)}m`;
}

export function getFeedbackIcon(thumbsUp: boolean, thumbsDown: boolean): string {
  if (thumbsUp) return "👍";
  if (thumbsDown) return "👎";
  return "—";
}

export function getFeedbackColor(thumbsUp: boolean, thumbsDown: boolean): string {
  if (thumbsUp) return "text-green-600";
  if (thumbsDown) return "text-red-600";
  return "text-gray-400";
}

/** Environment badge colouring. */
export function environmentClass(environment?: string): string {
  if (environment === "prod") return "bg-red-100 text-red-800";
  if (environment === "dev") return "bg-blue-100 text-blue-800";
  if (environment === "staging") return "bg-yellow-100 text-yellow-800";
  return "bg-gray-100 text-gray-800";
}
